<span title="{{ value ? value : 'Noname' }}">
  {{ getText() }}
</span>
